import PropTypes from "prop-types"
import React from "react"
import { renderClasses } from "utils/renderClasses"
import CallsToAction from "./CallsToAction"
import Logo from "./Logo"
import Menu from "./Menu"
import "./topnav.scss"

const TopNav = ({
  backgroundColor,
  callsToAction,
  isWholeChild,
  menu,
  menuOpen,
  menuToggleHandler,
}) => {
  return (
    <div
      className={renderClasses(
        "g-header-top-nav",
        [[backgroundColor, `--${backgroundColor}`]],
        [[menuOpen, "--open"]]
      )}
    >
      <div className="max-container">
        <Logo isWholeChild={isWholeChild} menuOpen={menuOpen} />
        <Menu
          {...menu}
          callsToAction={callsToAction}
          isWholeChild={isWholeChild}
          menuOpen={menuOpen}
          menuToggleHandler={menuToggleHandler}
        />
        <CallsToAction
          callsToAction={callsToAction}
          menuOpen={menuOpen}
          menuToggleHandler={menuToggleHandler}
        />
      </div>
    </div>
  )
}

TopNav.propTypes = {
  backgroundColor: PropTypes.string,
  callsToAction: PropTypes.arrayOf(PropTypes.shape(CallsToAction.props)),
  isWholeChild: PropTypes.bool,
  menu: PropTypes.shape(Menu.props),
  menuOpen: PropTypes.bool.isRequired,
  menuToggleHandler: PropTypes.func.isRequired,
}

export default TopNav
